<template>
  <div class="row justify-content-center">
    <div
      v-if="!loading && (!submissions.length)"
      class="alert alert-warning col-sm-6"
      role="alert"
    >{{lang().get('scheduling.posting_queue.no_more_submissions')}}!</div>
    <div v-if="!loading" class="col-12 col-lg-10" id="postingQsubList">
      <posting-list-item
        v-for="submission in submissions"
        v-bind:key="submission.id"
        :id="submission.id"
        :status="submission.status"
        :text="submission.text"
        :image_url="submission.image_url"
        :submission_time="submission.submission_time"
        :decision_time="submission.decision_time"
        :scheduled_post_time="submission.scheduled_post_time"
        :filter_phrases="submission.filter_phrases"
        :route_truth_details="submission.route_truth_details"
        :numbered="submission.numbered ? true : false"
        :header_text="submission.header_text"
        :nsfw_probability="submission.nsfw_probability"
        :instagram="submission.post_to_instagram ? true : false"
        @submission-dismissed="dismissSubmission"
        @submission-move-up="moveSubmissionUp"
        @submission-move-top="moveSubmissionTop"
        @submission-move-down="moveSubmissionDown"
        @submission-move-bottom="moveSubmissionBottom"
      ></posting-list-item>
    </div>
    <div v-else class="text-center">
      <i class="fa fa-spinner fa-pulse fa-fw fa-3x"></i>
    </div>

    <nav v-if="!loading && pagination.last_page > 1" aria-label="Page navigation">
      <ul class="pagination mb-0">
        <li v-bind:class="[{disabled: !pagination.prev_page_url}]" class="page-item">
          <a class="page-link" href="#" @click="fetchSubmissions(pagination.prev_page_url)">Previous</a>
        </li>

        <li class="page-item disabled">
          <a
            class="page-link text-dark"
            href="#"
          >Page {{ pagination.current_page }} of {{ pagination.last_page }}</a>
        </li>

        <li v-bind:class="[{disabled: !pagination.next_page_url}]" class="page-item">
          <a class="page-link" href="#" @click="fetchSubmissions(pagination.next_page_url)">Next</a>
        </li>
      </ul>
    </nav>

    <div v-if="!loading" class="row col-12 justify-content-center">
      <button
        class="btn btn-secondary btn-block m-2 col-md-4 px-2 rounded-pill bg-utred border-utred"
        @click="recalculateTimes()"
      >Re-calculate all posting times</button>
    </div>
  </div>
</template>


<script>
import PostingListItem from "./PostingListItem";
import SubButtons from "./SubButtons";

export default {
  name: "PostingList",

  components: {
    PostingListItem,
    SubButtons
  },

  data() {
    return {
      loading: true,
      submissions: [],
      pagination: []
    };
  },

  created() {
    this.fetchSubmissions();
  },

  // mounted() {},

  methods: {
    fetchSubmissions(page_url) {
      this.loading = true;
      var self = this;
      page_url = page_url || "/api/queues/posting";
      axios
        .get(page_url, {
          params: {
            orderDirection: this.order
          }
        })
        .then(function(response) {
          self.loading = false;
          // convert to an array (so we can easily get the length). Strange we have to data.data but something to do with pagination
          self.submissions = Object.values(response.data.data);
          self.makePagination(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    makePagination(response) {
      let pagination = {
        current_page: response.current_page,
        last_page: response.last_page,
        next_page_url: response.next_page_url,
        prev_page_url: response.prev_page_url
      };
      this.pagination = pagination;
    },

    dismissSubmission(submission) {
      let i = this.submissions.map(item => item.id).indexOf(submission.id); // find index of your object
      this.submissions.splice(i, 1); // remove it from array
      this.updateBottomIfValidOrRefreshAll();
      $(".tooltip").tooltip("hide"); //remove all tooltips
    },

    updateBottomIfValidOrRefreshAll() {
      let self = this;
      this.fetchLast2Submissions(this.pagination).then(function(bottomSubs) {
        if (bottomSubs.length >= 2) {
          //only works if we have 2 subs to check!
          if (
            bottomSubs[0].id == self.submissions[self.submissions.length - 1].id
          ) {
            self.submissions.push(bottomSubs[1]);
          } else if (
            bottomSubs[1].id ==
              self.submissions[self.submissions.length - 1].id &&
            bottomSubs[0].id == self.submissions[self.submissions.length - 2].id
          ) {
            //no difference, so don't do anything!
          } else {
            self.fetchSubmissions();
          }
        }
      });
    },
    fetchLast2Submissions: (
      pagination //return a promise (to go via ajax...? https://stackoverflow.com/questions/55071308/how-to-return-a-response-from-axios-in-vue, https://stackoverflow.com/questions/50395181/js-promise-in-vue-shows-as-undefined)
    ) => {
      //this.loading = true;
      let bottomSubs = null;
      return axios
        .get("/api/queues/posting/lastofpage", {
          params: {
            page: pagination.current_page,
            count: 2
          }
        })
        .then(function(response) {
          return Object.values(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    moveSubmissionUp(submission) {
      let i = this.submissions.map(item => item.id).indexOf(submission.id); // find index of your object
      if (i >= 1) {
        //check there is a position above
        let sub = this.submissions[i]; //get the (full submission), 'submission' is not the full thing.
        this.submissions.splice(i, 1); // remove it from array
        this.submissions.splice(i - 1, 0, sub); // re-add a position above
      }
    },
    moveSubmissionTop(submission) {
      let i = this.submissions.map(item => item.id).indexOf(submission.id); // find index of your object
      let sub = this.submissions[i]; //get the (full submission), 'submission' is not the full thing.
      this.submissions.splice(i, 1); // remove it from array
      this.submissions.splice(0, 0, sub); // re-add at top
    },
    moveSubmissionDown(submission) {
      let i = this.submissions.map(item => item.id).indexOf(submission.id); // find index of your object
      if (i < this.submissions.length) {
        //check there is a position above
        let sub = this.submissions[i]; //get the (full submission), 'submission' is not the full thing.
        this.submissions.splice(i, 1); // remove it from array
        this.submissions.splice(i + 1, 0, sub); // re-add a position below
      }
    },
    moveSubmissionBottom(submission) {
      let i = this.submissions.map(item => item.id).indexOf(submission.id); // find index of your object
      let sub = this.submissions[i]; //get the (full submission), 'submission' is not the full thing.
      this.submissions.splice(i, 1); // remove it from array
      this.submissions.splice(this.submissions.length, 0, sub); // re-add at bottom
    },
    recalculateTimes() {
      this.loading = true;
      let self = this;
      axios
        .post("/api/queues/posting/recalculatetimes")
        .then(function(response) {
          self.loading = false;
          self.fetchSubmissions();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
